module.exports = __webpack_public_path__ + "img/dingjiawei.acae880d.png";